import "./App.css";
import { API_BASE } from "./apiBase";
import Home from "./pages/Home/Home";
import Pricing from "./pages/Pricing/Pricing";

import ProductsPage from "./pages/Products/Products";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import OOSProductsPage from "./pages/OOSProducts/OOSProducts";
import ContactUs from "./pages/ContactUs/ContactUs";
import { useEffect, useState } from "react";
import FAQ from "./pages/FAQ/FAQ";
import Bundles from "./pages/Bundles/Bundles";
import Liquidations from "./pages/Liquidations/Liquidations";
import Footer from "./components/Footer";
import { useAuth0 } from "@auth0/auth0-react";
import Blogs from "./pages/Blogs/Blogs";
// SEO consolidation: IntroductionToAmazonFBA, StartingAmazonFBA, AmazonFbaProductSourcing,
// ListingProductsPricingStrategies retired — routes now redirect to canonical pillars.
import CustomerFeedback from "./pages/Blogs/blogs/CustomerFeedback";
import GettingStartedFBABeginners from "./pages/Blogs/blogs/GettingStartedFBABeginners";
import Affiliate from "./pages/Affiliate/Affiliate";
import SkyrocketSalesAmazonSeller from "./pages/Blogs/blogs/SkyrocketSalesAmazonSeller";
import TheBestAmazonArbitrageProducts from "./pages/Blogs/blogs/TheBestAmazonArbitrageProducts";
import HowToFindAmazonArbitrageProducts from "./pages/Blogs/blogs/HowToFindAmazonArbitrageProducts";
import AmazonArbitrageBoostProfit from "./pages/Blogs/blogs/AmazonArbitrageBoostProfit";
import HowToFindAmazonArbitrageProducts2 from "./pages/Blogs/blogs/HowToFindAmazonArbitrageProducts2";
import ExploringPrep from "./pages/Blogs/blogs/ExploringPrep";
import NepetoAlternatives from "./pages/Blogs/blogs/NepetoAlternatives";
import AffiliateDashboard from "./pages/AffiliateDashboard/AffiliateDashboard";
import GA from "./pages/Pricing/CustomPricing/GA";
import Whop from "./pages/Whop/Whop";
import Courses from "./pages/Courses/Courses";
import ChromeExtenstion from "./pages/ChromeExtenstion/ChromeExtenstion";
import WhatIsNepeto from "./pages/Blogs/blogs/WhatIsNepeto";
import WhySellOnAmazon from "./pages/Blogs/blogs/WhySellOnAmazon";
import Scanner from "./pages/Scanner/Scanner";
import A2AProductsPage from "./pages/AmazonFlips/A2AProducts";
import WhatAreOOSProducts from "./pages/Blogs/blogs/WhatAreOOSProducts";
import SuccessInQ4WithNepeto from "./pages/Blogs/blogs/SuccessInQ4WithNepeto";
import JimPricing from "./pages/Pricing/CustomPricing/Jim";
import JimProductsPage from "./pages/Products/JimProducts";
import A2WProductsPage from "./pages/AmazonToWalmart/A2WProducts";
import MismatchUpdate from "./pages/MismatchUpdate/MismatchUpdate";
import UserActivityDashboard from "./pages/UserActivityDashboard/UserActivityDashboard";
import Dashboard from "./pages/Dashboard/Dashboard";
import PackmanLoader from "./components/PacmanLoader";
import Joyride from 'react-joyride';
import StorefrontScanner from "./pages/StorefrontScanner/StorefrontScanner";
import HomeRoadmap from "./pages/HomeRoadmap/HomeRoadmap";
import GatedGuideTrigger from "./components/GatedGuideTrigger";
import FavoritesGuideTrigger from "./components/FavoritesGuideTrigger";
import StorefrontGuideTrigger from "./components/StorefrontGuideTrigger";
import StorefrontScanGuideTrigger from "./components/StorefrontScanGuideTrigger";
import ProductFinder from "./pages/ProductFinder/ProductFinder";
import AppExtLandingPage from "./pages/AppExtLandingPage/AppExtLandingPage";
import PrivacyTerms from "./components/PrivacyTerms";
import LiveSearch from "./pages/LiveSearch/LiveSearch";
import SubscribeButtonPayPal from "./pages/Pricing/components/SubscribeButtonPayPal";
import Admin from "./pages/Admin/Admin";
import RAEXTPricing from "./pages/Pricing/RAEXTPricing";
import SubscribeButtonPPG from "./pages/Pricing/components/SubscribeButtonPPG";
import NatePricing from "./pages/Pricing/CustomPricing/Nate";
import AdminSubscriptionDash from "./pages/AdminSubscriptionDash/AdminSubscriptionDash";
import MismatchGame from "./pages/MismatchGame/MismatchGame";
import CancellationPage from "./pages/CancellationPage/CancellationPage";
import AutomatedSourcing from "./pages/Automated-Sourcing/AutomatedSourcing";
import ProductSourcingSoftware from "./pages/Blogs/blogs/ProductSourcingSoftware";
import AmazonProductSourcing from "./pages/Blogs/blogs/AmazonProductSourcing";
import BestAmazonSourcingSoftware from "./pages/Blogs/blogs/BestAmazonSourcingSoftware";
import ManualVsAutomatedAmazonProductSourcing from "./pages/Blogs/blogs/ManualVsAutomatedAmazonProductSourcing";
import OnlineArbitrageSourcingTool from "./pages/Blogs/blogs/OnlineArbitrageSourcingTool";
import AutomatedAmazonSourcing from "./pages/Blogs/blogs/AutomatedAmazonSourcing";

function App() {
  const { isAuthenticated, isLoading, user, getAccessTokenSilently } = useAuth0();
  const [isMobile, setIsMobile] = useState(false);
  const [startSubscription, setStartSubscription] = useState(false);
  const [userStatsLoading, setUserStatsLoading] = useState(true);
  const [threeNotif, setThreeNotif] = useState(false); // disabled (was: localStorage.getItem("notCount") !== "1")
  const [threeNotVisible, setThreeNotVisible] = useState(false);
  const [phone, setPhone] = useState("");
  const [matches, setMatches] = useState(0);
  const [hidden, setHidden] = useState([]);
  const [hideCredits, setHideCredits] = useState(0);
  const [isAff, setIsAff] = useState(false);
  const [activePlanLevel, setActivePlanLevel] = useState("");
  // Whether /active_plan has answered yet (see getActivePlan below).
  const [activePlanLoaded, setActivePlanLoaded] = useState(false);
  const [nextBillingTime, setNextBillingTime] = useState("");
  const [subscriptionActive, setSubscriptionActive] = useState(undefined);
  const [justHide, setJustHide] = useState("");
  const [sellerId, setSellerId] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
  const [appExtMobile, setAppExtMobile] = useState(false); // disabled (was: localStorage.getItem("appExtMobile") !== "1")
  // const [pioPopup, setPioPopup] = useState(localStorage.getItem("pioneerPopup") !== "1");
  const [pioPopup, setPioPopup] = useState(false);
  const [videoPopup, setVideoPopup] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoArmKey, setVideoArmKey] = useState(0);
  const [mismatchGame, setMismatchGame] = useState(localStorage.getItem("MOMOpen") !== `${String(new Date().getMonth() + 1).padStart(2, '0')}${String(new Date().getDate()).padStart(2, '0')}`);
  // Onboarding is the /home roadmap + its per-step spotlights. The only tours
  // left here are the two GatedGuideTrigger sets it drives; the auto-running
  // "Arianna" tour and the GuideCircle per-page tours are gone.
  const [joyrideRun, setJoyrideRun] = useState("");
  const joyrideSteps = {
    "gatedFilter": [
      {
        "target": "#gatedFilterBtn",
        "title": "Find an ungated product",
        "content": "We've pre-selected a few categories new sellers are more likely to be ungated in. Now click here and choose \"Show Only Ungated ASINs\" to filter to products you can sell right away.",
        "disableBeacon": true,
        "disableScrolling": true,
        "spotlightClicks": true
      }],
    "gatedNextPage": [
      {
        "target": "#nextPageBtn",
        "title": "How the scan works",
        "content": "When you use these filters, Nepeto takes 200 products and checks your selling eligibility for each one. If only a few show up, click \"Next page\" to scan 200 more!",
        "disableBeacon": true,
        "disableScrolling": true,
        "spotlightClicks": true
      }],
  };

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // Check if the 'affiliate' parameter exists in the query string
    if (urlParams.has("subscribed")) {
      setStartSubscription(true);
    }
    if (window.location.href.includes("ultimateplan") && !urlParams.has("v")) {
      window.location.href += (window.location.href.includes("?") ? "&" : "?") + "v=1"
    }
    if (localStorage.getItem('affiliate') === null) {
      if (urlParams.has("a")) {
        localStorage.setItem("affiliate", urlParams.get('a'))
      } else if (urlParams.has("fbclid")) {
        localStorage.setItem("affiliate", "meta")
      } else if (urlParams.has("gclid")) {
        localStorage.setItem("affiliate", "google")
      }
    }
    if (urlParams.has("hide") && urlParams.has("asin") && !isLoading && isAuthenticated) {
      setJustHide(urlParams.get('asin'));
    }
    if (urlParams.has("hc") && urlParams.has("amount") && urlParams.has("hcid") && !isLoading && isAuthenticated) {
      const hideProductCreditsReq = async () => {
        const accessToken = await getAccessTokenSilently();
        fetch(API_BASE + "/add_hide_credits/" + urlParams.get('amount') + "/" + urlParams.get("hcid") + "/", {
          mode: "cors",
          headers: { Authorization: `Bearer ${accessToken}` },
        }).then((response) => response.json())
          .then((data) => {
            if (data === "yes") {
              setHideCredits(prev => prev + parseInt(urlParams.get('amount')))
            }
          });
      };
      hideProductCreditsReq()
    }
  }, [isLoading, isAuthenticated, getAccessTokenSilently]);

  // Check if it's a mobile device
  const checkIfMobile = (windowMatchMedia) => {
    if (windowMatchMedia.matches) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };


  // Check if it's mobile - init listeners
  useEffect(() => {
    const windowMatchMedia = window.matchMedia("(max-width: 700px)");
    checkIfMobile(windowMatchMedia); // Initial check

    const listener = (event) => checkIfMobile(event);

    windowMatchMedia.addEventListener("change", listener);

    return () => {
      windowMatchMedia.removeEventListener("change", listener);
    };
  }, []);

  // Update subscription status
  useEffect(() => {
    const updateSubscriptioon = async () => {
      const accessToken = await getAccessTokenSilently();
      fetch(API_BASE + "/update_subscription_status/" + (localStorage.getItem('affiliate') || 'none') + "/", {
        mode: "cors",
        headers: { Authorization: `Bearer ${accessToken}` },
      }).then((response) => response.json())
        .then((data) => {
          if (data !== "No permissions" && data !== "Succeed!") {
            setMatches(data[0]);
            setIsAff(!!data[1]);
            setHidden(data[2]);
            setHideCredits(prev => prev + data[3]);
            setNextBillingTime(data[4])
            setSubscriptionActive(data[5])
            setUserStatsLoading(false)
          }
        });;
    };

    if (!isLoading && isAuthenticated) {
      updateSubscriptioon();
    }
  }, [getAccessTokenSilently, isLoading, isAuthenticated]);

  // Update time spent
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      const timeStart = new Date();
      let cip = "";
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => { cip = data.ip })
        .catch(error => console.log(error))


      const updateTimeSpent = async () => {
        try {
          const accessToken = await getAccessTokenSilently();
          fetch(API_BASE + "/time_spent/" + ((new Date() - timeStart) / 1000) + "/" + cip + "/" + user.email + "/", {
            mode: "cors",
            headers: { Authorization: `Bearer ${accessToken}` },
          })
        } catch {
          console.log("ERR time spent")
        }
      };

      try {
        window.onbeforeunload = function () {
          try {
            updateTimeSpent();
          } catch {
            console.log("ERR time spent")
          }
        }
      } catch {
        console.log("ERR time spent")
      }

      const getActivePlan = async () => {
        const accessToken = await getAccessTokenSilently();
        fetch(
          API_BASE + "/active_plan",
          { mode: "cors", headers: { Authorization: `Bearer ${accessToken}` } }
        )
          .then((response) => response.json())
          .then((data) => {
            setActivePlanLevel(data)
            setActivePlanLoaded(true)
          })
          // A free trial answers with an empty level, which is also the initial
          // state — so "no plan" and "not fetched yet" are indistinguishable from
          // activePlanLevel alone. This flag is what tells them apart; a failed
          // fetch counts as resolved so nothing waits on it forever.
          .catch(() => setActivePlanLoaded(true));
      };
      if (!isLoading && isAuthenticated) {
        getActivePlan();
        const checkSellerId = async () => {
          const res = await fetch(API_BASE + "/mobile_app_get_amz_login/" + user.email + "/");
          const selId = await res.json();
          setSellerId(selId['spid'])
          setRefreshToken(selId['refreshtok'])
        }
        checkSellerId();
      }
    }
  }, [isLoading, isAuthenticated, user, getAccessTokenSilently])

  // Ungated-products video popup (no timer):
  // - "Close" sets localStorage "ungatedVideoPopup"=1 -> permanently dismissed, never auto-shows again.
  // - "Watch Later" / background click only session-dismisses -> shows again next login session.
  // - sessionStorage "ungatedVideoShown" survives refresh but clears on a fresh login session.
  useEffect(() => {
    if (isLoading) return;
    if (isAuthenticated) {
      if (localStorage.getItem("ungatedVideoPopup") !== "1" && sessionStorage.getItem("ungatedVideoShown") !== "1") {
        sessionStorage.setItem("ungatedVideoShown", "1");
        setVideoPopup(true);
      }
    } else {
      // logged out -> reset session flag so it can show again on next login session
      sessionStorage.removeItem("ungatedVideoShown");
    }
  }, [isLoading, isAuthenticated, videoArmKey])

  const sendPhone = async () => {
    try {
      if (phone !== "" && phone && phone.length > 1) {
        const accessToken = await getAccessTokenSilently();
        fetch(API_BASE + "/update-phone/" + phone + "/", {
          mode: "cors",
          headers: { Authorization: `Bearer ${accessToken}` },
        })
      }
    } catch {

    }
  }

  useEffect(() => {
    const head = document.querySelector('head');
    const script = document.createElement('script');
    script.setAttribute(
      'src',
      'https://assets.calendly.com/assets/external/widget.js'
    );
    head.appendChild(script);
  }, []);

  return (
    <BrowserRouter>
      <GatedGuideTrigger
        isMobile={isMobile}
        isAuthenticated={isAuthenticated}
        isLoading={isLoading}
        setJoyrideRun={setJoyrideRun}
      />
      <FavoritesGuideTrigger
        isMobile={isMobile}
        isAuthenticated={isAuthenticated}
        isLoading={isLoading}
      />
      <StorefrontGuideTrigger
        isMobile={isMobile}
        isAuthenticated={isAuthenticated}
        isLoading={isLoading}
        activePlanLevel={activePlanLevel}
        activePlanLoaded={activePlanLoaded}
      />
      <StorefrontScanGuideTrigger isMobile={isMobile} />
      {!isMobile && joyrideSteps.hasOwnProperty(joyrideRun) && <Joyride
        key={joyrideRun}
        steps={joyrideSteps[joyrideRun]}
        run={!isLoading && isAuthenticated}
        continuous={true}
        disableCloseOnEsc={true}
        disableOverlayClose={true}
        hideCloseButton={true}
        showSkipButton={true}
        callback={(e) => {
          // Clear when a tour ends so a later setJoyrideRun("...") reliably restarts
          // (e.g. the gated "Next page" spotlight after the first one was closed).
          if (e.status === "finished" || e.status === "skipped") { setJoyrideRun(""); }
        }}
        showProgress={joyrideSteps[joyrideRun].length > 1}
        locale={{ last: "Close" }}
        styles={{
          spotlight: {
            borderRadius: 20,
          },
          tooltip: {
            padding: '3%',
          },
          tooltipContainer: {
            textAlign: 'center',
          },
          tooltipTitle: {
            fontSize: '100%',
            padding: "3% 1% 1% 1%"
          },
          tooltipContent: {
            fontSize: "150%",
            padding: '3% 3% 2% 3%'
          },
          options: {
            arrowColor: '#E3D0DF',
            backgroundColor: '#E3D0DF',
            primaryColor: '#8c3e7c',
            textColor: 'black',
            zIndex: 999
          },
        }}
      />}

      <Navbar isAff={isAff} activePlanLevel={activePlanLevel} />
      <div class="montserrat newsMessage" style={{ backgroundColor: "rgba(250, 250, 100, 0.6)", boxShadow: "0px 0px 2px 0px black", marginTop: "1vh", width: "100vw", textAlign: "center", padding: "0" }}>
        <strong style={{ fontWeight: "1000" }}>
          <a href="/app-ext" target="_blank" rel="noreferrer" style={{ color: "darkgreen", textDecoration: "underline" }}>Download our Scanning App and Profit Calculator!</a>&emsp;{"|"}&emsp;
          <a href="https://www.facebook.com/share/ofb5faZtiNzMDmPs/?mibextid=K35XfP" target="_blank" rel="noreferrer" style={{ textDecoration: "underline" }}>Join our <i class="fa fa-facebook-official" aria-hidden="true"></i> Community!</a>
        </strong>
      </div>
      <Routes>
        <Route path="/">
          <Route index element={isLoading ? <PackmanLoader isMobile={isMobile} /> : (!isLoading && isAuthenticated) ? <Navigate to="/home" replace /> : <Home isMobile={isMobile} />} />
          <Route path="home" element={isLoading ? <PackmanLoader isMobile={isMobile} /> : (!isLoading && isAuthenticated) ? <HomeRoadmap isMobile={isMobile} user={user} openUngatedVideo={() => { setVideoLoaded(false); setVideoPopup(true); }} /> : <Navigate to="/" replace />} />
          <Route path="dashboard" element={isLoading ? <PackmanLoader isMobile={isMobile} /> : (!isLoading && isAuthenticated) ? <Dashboard openMOM={() => setMismatchGame(true)} openUngatedVideo={() => { setVideoLoaded(false); setVideoPopup(true); }} hideCredits={hideCredits} userStatsLoading={userStatsLoading} isMobile={isMobile} user={user} activePlanLevel={activePlanLevel} matches={matches} hidden={hidden} /> : <Navigate to="/" replace />} />
          <Route path="pricing" element={<Pricing activePlanLevel={activePlanLevel} nextBillingTime={nextBillingTime} subscriptionActive={subscriptionActive} isMobile={isMobile} />} />
          <Route path="pricing/ga" element={<GA activePlanLevel={activePlanLevel} isMobile={isMobile} />} />
          <Route path="pricing/silentjim" element={<JimPricing activePlanLevel={activePlanLevel} isMobile={isMobile} />} />
          <Route path="pricing/hustlebuddies" element={<NatePricing activePlanLevel={activePlanLevel} isMobile={isMobile} />} />
          <Route
            path="silentjim"
            element={
              <JimProductsPage sellerId={sellerId} refreshToken={refreshToken} isMobile={isMobile} supplierType={"silentjim"} matches={matches} hideCredits={hideCredits} activePlanLevel={activePlanLevel} />
            }
          />
          <Route
            path="retail"
            element={
              <ProductsPage sellerId={sellerId} refreshToken={refreshToken} isMobile={isMobile} supplierType={"retail"} matches={matches} hideCredits={hideCredits} activePlanLevel={activePlanLevel} />
            }
          />
          <Route
            path="distributors"
            element={
              <ProductsPage sellerId={sellerId} refreshToken={refreshToken} isMobile={isMobile} supplierType={"distributors"} matches={matches} hideCredits={hideCredits} activePlanLevel={activePlanLevel} />
            }
          />
          <Route
            path="wholesale"
            element={
              <ProductsPage sellerId={sellerId} refreshToken={refreshToken} isMobile={isMobile} supplierType={"wholesale"} matches={matches} hideCredits={hideCredits} activePlanLevel={activePlanLevel} />
            }
          />
          <Route path="oos" element={<OOSProductsPage sellerId={sellerId} refreshToken={refreshToken} isMobile={isMobile} matches={matches} hideCredits={hideCredits} activePlanLevel={activePlanLevel} />} />
          <Route path="contact" element={<ContactUs isMobile={isMobile} />} />
          <Route path="faq" element={<FAQ isMobile={isMobile} />} />
          <Route path="bundles" element={<Bundles isMobile={isMobile} />} />
          <Route
            path="liquidations"
            element={<Liquidations isMobile={isMobile} />}
          />
          <Route path="tutorials" element={<Courses isMobile={isMobile} />} />
          <Route path="whop" element={<Whop isMobile={isMobile} />} />
          <Route path="mmupdate" element={<MismatchUpdate />} />
          <Route path="affiliate" element={<Affiliate isMobile={isMobile} />} />
          <Route path="affiliate-dashboard" element={<AffiliateDashboard isMobile={isMobile} />} />
          <Route path="user-activity" element={<UserActivityDashboard isMobile={isMobile} />} />
          <Route path="how-to-use-nepeto" element={<Courses isMobile={isMobile} />} />
          <Route path="chrome-extension" element={<ChromeExtenstion isMobile={isMobile} />} />
          <Route path="amazon-flips" element={<A2AProductsPage sellerId={sellerId} refreshToken={refreshToken} isMobile={isMobile} matches={matches} hideCredits={hideCredits} activePlanLevel={activePlanLevel} />} />
          <Route path="amazon-to-walmart" element={<A2WProductsPage isMobile={isMobile} matches={matches} hideCredits={hideCredits} activePlanLevel={activePlanLevel} />} />
          <Route path="csv-scanner" element={<Scanner sellerId={sellerId} refreshToken={refreshToken} isMobile={isMobile} hideCredits={hideCredits} activePlanLevel={activePlanLevel} />} />
          <Route path="storefront-scanner" element={<StorefrontScanner sellerId={sellerId} refreshToken={refreshToken} isMobile={isMobile} activePlanLevel={activePlanLevel} hideCredits={hideCredits} />} />
          <Route path="master-search" element={<ProductFinder sellerId={sellerId} refreshToken={refreshToken} isMobile={isMobile} activePlanLevel={activePlanLevel} hideCredits={hideCredits} />} />
          <Route path="app-ext" element={<AppExtLandingPage isMobile={isMobile} />} />
          <Route path="privacyterms" element={<PrivacyTerms />} />
          <Route path="nepeto-ai-sourcing" element={<AutomatedSourcing />} />
          <Route path="ultimateplan" element={<div>
            <img alt="nepmar" src="/assets/marteroa.png" style={{ margin: "auto", display: "block", width: "50%", marginTop: "15px" }} />
            <img alt="moa" src="/assets/moa.png" style={{ margin: "auto", display: "block", width: "25%" }} />
            {window.location.href.includes("silentjim") && <img alt="aff" src="/assets/jim.jpg" style={{ margin: "auto", display: "block", width: "10%", borderRadius: "50px" }} />}
            {window.location.href.includes("hustlebuddies") && <img alt="aff" src="/assets/nate.png" style={{ margin: "auto", display: "block", width: "10%", borderRadius: "50px" }} />}
            {window.location.href.includes("7figuregrammy") && <img alt="aff" src="https://ugc.production.linktr.ee/6sxEPwpgRjWhEVa93RUQ_2al0Rw0J54LCxUcH?io=true&size=avatar-v3_0" style={{ margin: "auto", display: "block", width: "10%", borderRadius: "50px" }} />}
            {['bfpedro.jpg', 'bfa.jpg', 'bfabra.jpg', 'bfav.jpg', 'bfbb.jpg', 'bfbo.jpg', 'bfcodyf.jpg', 'bfid.jpg', 'bfjoe.jpg', 'bfmark.jpg', 'bfmu.jpg', 'bfn.jpg', 'bfreb.jpg', 'bfsar.jpg', 'bfsfat.jpg', 'bfy.jpg'].map((n) => {
              return window.location.href.split("?a=").pop().replace("&v=1", "") === n.split(".")[0] ? <img alt="aff" src={`/assets/${n}`} style={{ margin: "auto", display: "block", width: "10%", borderRadius: "50px" }} /> : <></>
            }
            )}
            <h1
              style={{
                fontSize: isMobile ? "3vh" : "2vw",
                fontWeight: "380",
                textAlign: "center",
                color: "#8c3e7c",
                marginBottom: isMobile && "2vh",
              }}
            >
              <h1
                style={{
                  fontSize: isMobile ? "4vh" : "3vw",
                  fontWeight: "980",
                  textAlign: "center",
                  color: "#8c3e7c",
                  marginBottom: isMobile && "3vh",
                }}
              >LIMITED TIME Bundle</h1>
              <a href="/pricing" target="_blank" rel="noreferrer" style={{ color: "#8c3e7c" }}><img src="/assets/proFlower2.png" style={{ width: "1.9%" }} />Master Plan</a> <span style={{ textDecoration: "line-through", color: "#8c3e7c", fontSize: "80%" }}>($112)</span>&emsp;+&emsp;<a href="https://www.getmarter.com" target="_blank" rel="noreferrer" style={{ color: "#FFC90E" }}><img src="/assets/marter.jpg" style={{ width: "6%" }} /></a> <span style={{ textDecoration: "line-through", color: "#FFC90E", fontSize: "80%" }}>($24)</span>&emsp;+&emsp;<a href="https://www.marteroa.com/" target="_blank" rel="noreferrer" style={{ color: "#FFC90E" }}><img src="/assets/moa.png" style={{ width: "6%" }} /></a> <span style={{ textDecoration: "line-through", color: "#FFC90E", fontSize: "80%" }}>($19.99)</span> = <span style={{ textDecoration: "line-through", color: "red", fontWeight: "900" }}>$155.99</span></h1>
            <span style={{ backgroundColor: "#f39c12", color: "black", fontWeight: "900", margin: "auto", textAlign: "center", textDecoration: "underline", borderRadius: "5px", padding: "4px", display: "table", cursor: "pointer" }} onClick={() => window.location.href = "/pricing"}>Not selling on Walmart yet? Click here to grab Nepeto's Master Plan and its amazing Black Friday deal!</span>
            <br /><br />
            <h1
              style={{
                fontSize: isMobile ? "4vh" : "3vw",
                fontWeight: "980",
                textAlign: "center",
                color: "#8c3e7c",
                marginBottom: isMobile && "3vh",
              }}
            >For Only <span style={{ fontSize: "165%", color: "green" }}>$68</span>/Month for LIFE!</h1>
            <br />
            <div style={{
              margin: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "5px",
              textAlign: "center",
              width: "25%"
            }}>
              <span style={{ fontSize: "400%" }}>→→→</span><SubscribeButtonPPG prd_id={"101492"} text={"Click here to start using Credit/Debit Card!"} ultimatePlan={true} /><span style={{ fontSize: "400%" }}>←←←</span>
            </div>
            <br /><br /><br />
            <h1
              style={{
                fontSize: isMobile ? "3vh" : "2vw",
                fontWeight: "380",
                textAlign: "center",
                width: "80%",
                margin: "auto",
                color: "#8c3e7c",
                marginBottom: isMobile && "3vh",
              }}
            >How to activate the bundle after purchasing:
              The Master Plan will apply automatically. To activate the Marter & MOA subscriptions, send an email to info@getmarter.com with your Nepeto and Marter email addresses, mentioning the bundle. They will apply it for you as soon as possible.</h1>
            <br /><br /><br /><br /><br /><br /><br /><br />
          </div>} />
          <Route path="live-search" element={<LiveSearch activePlanLevel={activePlanLevel} sellerId={sellerId} refreshToken={refreshToken} isMobile={isMobile} hideCredits={hideCredits} />} />
          <Route path="admin-ig-private" element={<Admin />} />
          <Route path="ra-ext-pricing" element={<RAEXTPricing isMobile={isMobile} />} />
          <Route path="sd-user" element={<AdminSubscriptionDash />} />
          <Route path="blog/product-sourcing-software" element={<ProductSourcingSoftware />} />
          <Route path="blog/amazon-product-sourcing" element={<AmazonProductSourcing />} />
          <Route path="blog/best-amazon-sourcing-software" element={<BestAmazonSourcingSoftware />} />
          <Route path="blog/manual-vs-automated-amazon-product-sourcing" element={<ManualVsAutomatedAmazonProductSourcing />} />
          <Route path="blog/online-arbitrage-sourcing-tool" element={<OnlineArbitrageSourcingTool />} />
          <Route path="blog/automated-amazon-sourcing" element={<AutomatedAmazonSourcing />} />
          <Route path="blog/*" element={<Blogs isMobile={isMobile} />} />
          <Route
            path="*"
            element={
              <div
                style={{
                  textAlign: "center",
                  marginTop: "10vh",
                  marginBottom: "70vh",
                }}
              >
                Page not found.
              </div>
            }
          />

          {/* Blogs */}
          <Route
            path="blog/getting-started-with-amazon-fba-for-beginners"
            element={<GettingStartedFBABeginners isMobile={isMobile} />}
          />

          {/* SEO consolidation: thin posts redirected to their canonical pillar */}
          <Route
            path="blog/what-is-amazon-fba"
            element={<Navigate to="/blog/getting-started-with-amazon-fba-for-beginners" replace />}
          />
          <Route
            path="blog/starting-amazon-fba-business"
            element={<Navigate to="/blog/getting-started-with-amazon-fba-for-beginners" replace />}
          />
          <Route path="blog/why-sell-on-amazon" element={<WhySellOnAmazon />} />
          <Route
            path="blog/amazon-fba-product-sourcing"
            element={<Navigate to="/blog/amazon-product-sourcing" replace />}
          />

          <Route
            path="blog/listing-products-and-pricing-strategies"
            element={<Navigate to="/blog/how-to-skyrocket-your-sales-as-an-amazon-fba-seller" replace />}
          />
          <Route
            path="blog/best-practices-for-customer-relations-and-feedback-management"
            element={<CustomerFeedback />}
          />
          <Route
            path="blog/growth-strategies-and-profit-maximization"
            element={<Navigate to="/blog/how-to-skyrocket-your-sales-as-an-amazon-fba-seller" replace />}
          />

          <Route
            path="blog/how-to-skyrocket-your-sales-as-an-amazon-fba-seller"
            element={<SkyrocketSalesAmazonSeller />}
          />

          <Route
            path="blog/the-best-products-for-amazon-arbitrage"
            element={<TheBestAmazonArbitrageProducts />}
          />

          <Route
            path="blog/how-to-find-amazon-arbitrage-products"
            element={<HowToFindAmazonArbitrageProducts />}
          />

          <Route
            path="blog/amazon-arbitrage-boost-profit"
            element={<AmazonArbitrageBoostProfit />}
          />

          <Route
            path="blog/how-to-find-amazon-arbitrage-products-in-2023-part-2"
            element={<HowToFindAmazonArbitrageProducts2 />}
          />

          <Route
            path="blog/exploring-the-world-of-fba-prep"
            element={<ExploringPrep />}
          />

          <Route
            path="blog/top-nepeto-alternatives-for-2023"
            element={<NepetoAlternatives />}
          />

          <Route
            path="blog/what-is-nepeto"
            element={<WhatIsNepeto />}
          />

          <Route
            path="blog/why-fba-prep-is-crucial"
            element={<Navigate to="/blog/exploring-the-world-of-fba-prep" replace />}
          />

          <Route
            path="blog/what-are-oos-products"
            element={<WhatAreOOSProducts />}
          />

          <Route
            path="blog/success-in-q4-with-nepeto"
            element={<SuccessInQ4WithNepeto />}
          />
          <Route
            path="/cancel"
            element={<CancellationPage />}
          />
        </Route>
      </Routes>

      {localStorage.getItem("acceptCookies") === null && (
        <div className="notification is-link is-light cookiesPopup">
          We use cookies. Click <a href="/cookies.pdf">here</a> for
          details.&emsp;
          <button
            className="acceptCookies"
            onClick={(e) => {
              localStorage.setItem("acceptCookies", "yes");
              e.target.offsetParent.style.display = "none";
            }}
          >
            Accept
          </button>
        </div>
      )}

      {isMobile && appExtMobile && window.location.pathname === "/" && (
        <div id="modal-js-example" className="modal is-active">
          <div class="modal-background" onClick={() => { setAppExtMobile(false); }}></div>

          <div className="modal-content" style={{ width: isMobile ? "90vw" : "40vw" }}>
            <div className="box" style={{ textAlign: "center" }}>
              <p style={{ fontSize: "200%" }}>Looking for our Retail Arbitrage Scanning Mobile App?</p><br />
              <br />
              <button class="button is-success" style={{ fontSize: isMobile ? "170%" : "1.8vw" }} onClick={() => { setAppExtMobile(false); window.location.href = "/app-ext" }}>Click Here</button>
              <br /><br /><button class="button is-danger" onClick={() => { setAppExtMobile(false); localStorage.setItem("appExtMobile", "1"); }}>Don't Show Again</button>
            </div>
          </div>
        </div>
      )}

      {pioPopup && (
        <div id="modal-js-example" className="modal is-active">
          <div class="modal-background" onClick={() => { setPioPopup(false); }}></div>

          <div className="modal-content" style={{ width: isMobile ? "90vw" : "40vw" }}>
            <div className="box" style={{ textAlign: "center" }}>
              <h1 style={{ fontSize: '200%' }}>Interested in selling on Walmart?</h1><br />
              <p style={{ fontSize: "200%" }}>Join Marter's Facebook Community!</p><br />
              <br />
              <button class="button is-success" style={{ fontSize: isMobile ? "170%" : "1.8vw" }} onClick={() => { setPioPopup(false); window.open("https://www.facebook.com/share/g/18pJUXhXtj/") }}>Click Here</button>
              <br /><br /><button class="button is-danger" onClick={() => { setPioPopup(false); localStorage.setItem("pioneerPopup", "1"); }}>Don't Show Again</button>
            </div>
          </div>
        </div>
      )}

      {startSubscription && (
        <div id="modal-js-example" class="modal is-active" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div class="modal-background" onClick={() => { setStartSubscription(false); sendPhone(); window.location.href = "https://nepeto.com/"; }} style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)'
          }}></div>

          <div class="modal-content" style={{
            width: "90%",
            maxWidth: "650px",
            position: 'relative',
            zIndex: 1001
          }}>
            <div class="box" style={{
              padding: isMobile ? "2.5rem 1.5rem" : "4rem 3.5rem",
              background: "white",
              borderRadius: "12px",
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)"
            }}>

              <h1 style={{
                fontSize: isMobile ? "2rem" : "2.8rem",
                fontWeight: "800",
                color: "#2c2c2c",
                marginBottom: "0.75rem",
                lineHeight: "1.2",
                fontFamily: "system-ui, -apple-system, sans-serif"
              }}>
                ✓ You're all set
              </h1>

              <p style={{
                fontSize: isMobile ? "1.1rem" : "1.25rem",
                color: "#666",
                marginBottom: "2.5rem",
                fontWeight: "400",
                lineHeight: "1.5"
              }}>
                Thanks for subscribing to Nepeto
              </p>

              <div style={{
                background: "#f8f8f8",
                borderRadius: "8px",
                padding: isMobile ? "1.75rem 1.25rem" : "2.25rem 2rem",
                marginBottom: "2rem",
                borderLeft: "4px solid #8B3C7E"
              }}>
                <p style={{
                  fontSize: isMobile ? "1.05rem" : "1.2rem",
                  color: "#2c2c2c",
                  marginBottom: "0.75rem",
                  fontWeight: "600",
                  lineHeight: "1.4"
                }}>
                  Want to learn how to make money with Nepeto?
                </p>
                <p style={{
                  fontSize: isMobile ? "0.95rem" : "1rem",
                  color: "#666",
                  marginBottom: "1.25rem",
                  lineHeight: "1.5"
                }}>
                  Check out our tutorials to get started
                </p>

                <a
                  href="/tutorials"
                  onClick={() => setStartSubscription(false)}
                  class="button"
                  style={{
                    background: "#8B3C7E",
                    color: "white",
                    fontWeight: "600",
                    border: "none",
                    borderRadius: "4px",
                    padding: "0.9rem 1.8rem",
                    fontSize: "1.05rem"
                  }}
                >
                  View tutorials
                </a>
              </div>

              <div style={{
                marginBottom: "2rem",
                textAlign: "left"
              }}>
                <label style={{
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  color: "#2c2c2c",
                  marginBottom: "0.5rem",
                  display: "block"
                }}>
                  Feel free to contact us!
                </label>
                <p class="control has-icons-left" style={{ position: 'relative' }}>
                  <a
                    style={{
                      display: 'block',
                      border: "2px solid #e0e0e0",
                      borderRadius: "6px",
                      fontSize: "1rem",
                      padding: "0.75rem 1rem 0.75rem 2.75rem",
                      textDecoration: 'none',
                      color: '#666'
                    }}
                    href="mailto:support@nepeto.com">support@nepeto.com</a>
                  <span class="icon is-small is-left" style={{
                    color: "#999",
                    position: 'absolute',
                    left: '0.5rem',
                    top: '50%',
                    transform: 'translateY(-50%)'
                  }}>
                    <i class="fa fa-envelope"></i>
                  </span>
                </p>
              </div>

              <button
                class="button is-success"
                style={{
                  width: "100%",
                  borderRadius: "6px",
                  fontWeight: "600",
                  fontSize: "1.1rem",
                  padding: "1rem",
                  background: "#10b981",
                  color: "white",
                  border: "none",
                  cursor: "pointer"
                }}
                onClick={() => { setStartSubscription(false); window.location.href = "https://nepeto.com/"; }}
              >
                Continue to Nepeto
              </button>

            </div>
          </div>
        </div>
      )
      }

      {
        justHide && (
          <div id="modal-js-example" class="modal is-active">
            {/* The Hidden Products block lives on /dashboard now ("/" redirects
                authed users to the /home roadmap). */}
            <div class="modal-background" onClick={() => window.location.href = "/dashboard"}></div>

            <div class="modal-content">
              <div class="box" style={{ textAlign: "center" }}>
                <p style={{ fontSize: "200%" }}><strong>{justHide}</strong> will be hidden from other Nepeto users!</p><br />
                <p>You will be able to see how many days are left in 'My Hidden Products'<br />or on the dashboard by clicking 'Show' under 'Hidden Products'.</p>
                <br /><br /><button class="button is-success" onClick={() => window.location.href = "/dashboard"}>Okay</button>
              </div>
            </div>
          </div>
        )
      }

      {
        threeNotif && !isMobile && <div className="tutNotify" style={{ zIndex: "999999999", cursor: "pointer", position: "sticky", width: "3vw", height: "3vw", bottom: "25px", left: "10px", backgroundColor: "#e6cede", borderRadius: "1000px", textAlign: "center", boxShadow: "0px 0px 10px 0px #8c3e7c" }}>
          <i className="fa fa-bell-o tutNotifyIcon" aria-hidden="true" style={{ fontSize: "1.5vw", padding: "0.75vw" }} onClick={() => setThreeNotVisible(p => !p)}></i>

          {threeNotVisible && <div style={{ position: 'absolute', marginTop: "-10vw", width: "20vw", height: "6vw", border: "4px solid #8c3e7c", borderRadius: "30px", backgroundColor: "white", boxShadow: "0px 0px 10px 0px gray", cursor: "default", fontSize: "0.63vw" }}>
            <span style={{ margin: "2.5%", textAlign: "left", display: "flex" }}><div style={{ textAlign: "center", borderRadius: "30px", backgroundColor: "purple", color: "white", padding: "0.3% 2%", marginRight: "2%" }}>2</div> Join our Facebook Community. &nbsp;<a target="_blank" rel="noreferrer" href="https://www.facebook.com/share/ofb5faZtiNzMDmPs/?mibextid=K35XfP">Click here to join.</a></span>
            <button onClick={() => { localStorage.setItem("notCount", "1"); setThreeNotif(false) }} style={{ fontFamily: "sans-serif", fontSize: "120%", cursor: "pointer", backgroundColor: "lightgreen", border: "0px", boxShadow: "0px 0px 5px 0px gray", borderRadius: "30px", marginLeft: "2%", cursor: "pointer" }}>Got all must-do’s done! <i class="fa fa-check" aria-hidden="true"></i></button>
          </div>}
        </div>
      }

      {!isLoading && isAuthenticated && videoPopup && (
        <div id="modal-js-example" className="modal is-active">
          <div className="modal-background" onClick={() => { setVideoPopup(false); setVideoLoaded(false); }}></div>

          <div className="modal-content" style={{ width: isMobile ? "92vw" : "55vw" }}>
            <div className="box" style={{ textAlign: "center" }}>
              <h1 style={{ fontSize: isMobile ? "1.6rem" : "2rem", fontWeight: "800", color: "#2c2c2c", marginBottom: "0.5rem" }}>
                Find Ungated Products — Easily, At Any Level
              </h1>
              <p style={{ fontSize: isMobile ? "1rem" : "1.15rem", color: "#666", marginBottom: "1.25rem" }}>
                Watch this quick video to see how to find ungated products with Nepeto — whether you're just starting out or already scaling.
              </p>

              <div style={{ position: "relative", width: "100%", paddingTop: "56.25%", borderRadius: "10px", overflow: "hidden", background: "#000", marginBottom: "1.5rem" }}>
                {videoLoaded ? (
                  <iframe
                    title="Ungated Products Guide"
                    src="https://drive.google.com/file/d/1NK3GHoJUd-oIG_4WD6sJLWqOaLTvcCDY/preview"
                    allow="autoplay"
                    allowFullScreen
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "0" }}
                  ></iframe>
                ) : (
                  <button
                    onClick={() => setVideoLoaded(true)}
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "0", cursor: "pointer", background: "linear-gradient(135deg, #8B3C7E, #5a2653)", color: "white", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "0.75rem" }}
                  >
                    <span style={{ fontSize: isMobile ? "3rem" : "4rem", lineHeight: 1 }}>▶</span>
                    <span style={{ fontSize: isMobile ? "1.1rem" : "1.3rem", fontWeight: "700" }}>Play Video</span>
                  </button>
                )}
              </div>

              <a
                href="https://drive.google.com/file/d/1NK3GHoJUd-oIG_4WD6sJLWqOaLTvcCDY/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
                style={{ display: "inline-block", marginBottom: "1rem", color: "#8B3C7E", fontWeight: "600" }}
              >
                Open video in Google Drive
              </a>
              <br />
              <button className="button is-light" style={{ marginRight: "0.75rem" }} onClick={() => { setVideoPopup(false); setVideoLoaded(false); }}>Watch Later</button>
              <button className="button is-danger" onClick={() => { setVideoPopup(false); setVideoLoaded(false); localStorage.setItem("ungatedVideoPopup", "1"); }}>Close</button>
            </div>
          </div>
        </div>
      )}

      {!isLoading && isAuthenticated && mismatchGame && <MismatchGame isMobile={isMobile} closeModal={() => { setMismatchGame(false); localStorage.setItem("MOMOpen", `${String(new Date().getMonth() + 1).padStart(2, '0')}${String(new Date().getDate()).padStart(2, '0')}`) }} />}

      <Footer isMobile={isMobile} />
    </BrowserRouter >
  );
}

export default App;
